import { FunctionComponent } from "react";

export interface Props {
  className?: string;
  fill?: string;
  width?: number;
  height?: number;
}

const TwitterIcon: FunctionComponent<Props> = ({
  className = "",
  fill = "",
  width = 40,
  height = 40,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Twitter</title>
      <path
        d="M22.667 17.8573L33.0917 6H30.6217L21.5658 16.2934L14.3382 6H6L16.9321 21.5668L6 34H8.47L18.0274 23.1273L25.6618 34H34L22.667 17.8573ZM19.2828 21.7035L18.1735 20.1524L9.36075 7.82205H13.1552L20.2694 17.7768L21.3741 19.3278L30.6205 32.2667H26.8261L19.2828 21.7035Z"
        fill={fill}
      />
    </svg>
  );
};

export default TwitterIcon;
